import { Client, ChecklistItem, ClientAccess, AdminTask } from '@/types';

// Clients Mock Data
export const clients: Client[] = [
  {
    id: 'client-001',
    restaurantId: '39v',
    restaurantName: 'Le 39V',
    status: 'negociation',
    pack: 'premium',
    monthlyRevenue: 2000,
    primaryContact: {
      name: 'Jean Dupont',
      email: 'j.dupont@le39v.com',
      phone: '+33 1 42 25 39 39',
      role: 'Directeur Marketing'
    },
    billing: {
      method: 'transfer',
      frequency: 'monthly',
    },
    onboarding: {
      completionRate: 15,
      startedAt: '2025-11-03',
    },
    notes: 'Client très motivé, besoin urgent d\'améliorer leur visibilité internationale. Signature imminente !'
  },
  {
    id: 'client-002',
    restaurantId: 'cafe-max',
    restaurantName: 'Café Max',
    status: 'negociation',
    pack: 'premium',
    monthlyRevenue: 2000,
    primaryContact: {
      name: 'Marie Martin',
      email: 'marie@cafemax-paris.fr',
      phone: '+33 1 45 51 52 53',
      role: 'Gérante'
    },
    billing: {
      method: 'card',
      frequency: 'monthly',
    },
    onboarding: {
      completionRate: 10,
      startedAt: '2025-11-03',
    },
    notes: 'Nouveau restaurant qui souhaite partir sur de bonnes bases SEO. Très réceptif aux conseils.'
  }
];

// Checklist Template pour Pack Premium
export const premiumOnboardingChecklist: ChecklistItem[] = [
  // COMMERCIAL
  {
    id: 'check-001',
    category: 'commercial',
    title: 'Devis formel',
    description: 'Créer et envoyer le devis détaillé pour le Pack Premium (2000€/mois)',
    status: 'pending',
    priority: 'high',
    subtasks: [
      { id: 'sub-001-1', title: 'Rédiger le devis avec détails des prestations', completed: false },
      { id: 'sub-001-2', title: 'Ajouter le plan d\'action SEO personnalisé', completed: false },
      { id: 'sub-001-3', title: 'Envoyer par email et confirmer réception', completed: false },
    ]
  },
  {
    id: 'check-002',
    category: 'commercial',
    title: 'Contrat de service / CGV',
    description: 'Faire signer le contrat de prestation et les CGV',
    status: 'pending',
    priority: 'high',
    subtasks: [
      { id: 'sub-002-1', title: 'Préparer le contrat de prestation SEO', completed: false },
      { id: 'sub-002-2', title: 'Joindre les CGV STRATOS', completed: false },
      { id: 'sub-002-3', title: 'Obtenir la signature (électronique ou physique)', completed: false },
      { id: 'sub-002-4', title: 'Archiver les documents signés', completed: false },
    ]
  },
  {
    id: 'check-003',
    category: 'commercial',
    title: 'Modalités de paiement',
    description: 'Définir et mettre en place les modalités de paiement',
    status: 'pending',
    priority: 'high',
    subtasks: [
      { id: 'sub-003-1', title: 'Choisir la méthode de paiement (virement/CB)', completed: false },
      { id: 'sub-003-2', title: 'Configurer la facturation récurrente', completed: false },
      { id: 'sub-003-3', title: 'Envoyer la première facture', completed: false },
    ]
  },
  {
    id: 'check-004',
    category: 'commercial',
    title: 'Calendrier projet',
    description: 'Établir le calendrier des livrables et jalons du projet',
    status: 'pending',
    priority: 'medium',
    subtasks: [
      { id: 'sub-004-1', title: 'Planifier l\'audit initial (J+7)', completed: false },
      { id: 'sub-004-2', title: 'Définir les dates de reporting mensuel', completed: false },
      { id: 'sub-004-3', title: 'Programmer les points de suivi hebdomadaires', completed: false },
    ]
  },
  
  // LEGAL
  {
    id: 'check-005',
    category: 'legal',
    title: 'NDA / Confidentialité',
    description: 'Accord de confidentialité pour accès aux données sensibles',
    status: 'pending',
    priority: 'medium',
    subtasks: [
      { id: 'sub-005-1', title: 'Préparer l\'accord de confidentialité', completed: false },
      { id: 'sub-005-2', title: 'Faire signer par les deux parties', completed: false },
    ]
  },
  {
    id: 'check-006',
    category: 'legal',
    title: 'Mentions légales et RGPD',
    description: 'Vérifier la conformité RGPD du site client',
    status: 'pending',
    priority: 'low',
    subtasks: [
      { id: 'sub-006-1', title: 'Auditer les mentions légales du site', completed: false },
      { id: 'sub-006-2', title: 'Vérifier la politique de confidentialité', completed: false },
      { id: 'sub-006-3', title: 'Proposer corrections si nécessaire', completed: false },
    ]
  },

  // TECHNIQUE
  {
    id: 'check-007',
    category: 'technical',
    title: 'Accès WordPress / CMS',
    description: 'Obtenir les accès administrateur au site',
    status: 'pending',
    priority: 'high',
    subtasks: [
      { id: 'sub-007-1', title: 'Demander accès admin WordPress', completed: false },
      { id: 'sub-007-2', title: 'Tester la connexion', completed: false },
      { id: 'sub-007-3', title: 'Documenter les accès (coffre-fort)', completed: false },
    ]
  },
  {
    id: 'check-008',
    category: 'technical',
    title: 'Google Analytics / GA4',
    description: 'Accès à Google Analytics pour tracking des performances',
    status: 'pending',
    priority: 'high',
    subtasks: [
      { id: 'sub-008-1', title: 'Demander accès Google Analytics', completed: false },
      { id: 'sub-008-2', title: 'Vérifier la configuration GA4', completed: false },
      { id: 'sub-008-3', title: 'Créer des rapports personnalisés', completed: false },
    ]
  },
  {
    id: 'check-009',
    category: 'technical',
    title: 'Google Search Console',
    description: 'Accès à Search Console pour monitoring SEO',
    status: 'pending',
    priority: 'high',
    subtasks: [
      { id: 'sub-009-1', title: 'Demander accès Search Console', completed: false },
      { id: 'sub-009-2', title: 'Vérifier les propriétés configurées', completed: false },
      { id: 'sub-009-3', title: 'Soumettre le sitemap XML', completed: false },
    ]
  },
  {
    id: 'check-010',
    category: 'technical',
    title: 'Google My Business / GBP',
    description: 'Accès à la fiche Google Business Profile',
    status: 'pending',
    priority: 'high',
    subtasks: [
      { id: 'sub-010-1', title: 'Demander accès Google Business Profile', completed: false },
      { id: 'sub-010-2', title: 'Vérifier les informations de la fiche', completed: false },
      { id: 'sub-010-3', title: 'Optimiser la fiche (photos, description)', completed: false },
    ]
  },
  {
    id: 'check-011',
    category: 'technical',
    title: 'Hébergeur / FTP',
    description: 'Accès serveur pour interventions techniques si nécessaire',
    status: 'pending',
    priority: 'medium',
    subtasks: [
      { id: 'sub-011-1', title: 'Identifier l\'hébergeur', completed: false },
      { id: 'sub-011-2', title: 'Demander accès FTP/SFTP si besoin', completed: false },
      { id: 'sub-011-3', title: 'Documenter les informations serveur', completed: false },
    ]
  },
  {
    id: 'check-012',
    category: 'technical',
    title: 'Outils SEO tiers',
    description: 'Connecter les outils SEO professionnels (Semrush, Ahrefs...)',
    status: 'pending',
    priority: 'medium',
    subtasks: [
      { id: 'sub-012-1', title: 'Configurer projet Semrush', completed: false },
      { id: 'sub-012-2', title: 'Configurer suivi positions', completed: false },
      { id: 'sub-012-3', title: 'Configurer alertes et rapports', completed: false },
    ]
  },

  // OPERATIONAL
  {
    id: 'check-013',
    category: 'operational',
    title: 'Kick-off meeting',
    description: 'Réunion de lancement du projet avec le client',
    status: 'pending',
    priority: 'high',
    subtasks: [
      { id: 'sub-013-1', title: 'Planifier le rendez-vous (visio/présentiel)', completed: false },
      { id: 'sub-013-2', title: 'Préparer la présentation du plan d\'action', completed: false },
      { id: 'sub-013-3', title: 'Définir les objectifs et KPIs', completed: false },
      { id: 'sub-013-4', title: 'Rédiger le compte-rendu', completed: false },
    ]
  },
  {
    id: 'check-014',
    category: 'operational',
    title: 'Audit SEO initial complet',
    description: 'Réaliser l\'audit SEO technique et éditorial détaillé',
    status: 'pending',
    priority: 'high',
    dueDate: '2025-11-10',
    subtasks: [
      { id: 'sub-014-1', title: 'Audit technique (crawl, vitesse, mobile)', completed: false },
      { id: 'sub-014-2', title: 'Audit on-page (meta, contenus, structure)', completed: false },
      { id: 'sub-014-3', title: 'Audit off-page (backlinks, citations)', completed: false },
      { id: 'sub-014-4', title: 'Rédiger le rapport d\'audit', completed: false },
    ]
  },
  {
    id: 'check-015',
    category: 'operational',
    title: 'Recherche de mots-clés',
    description: 'Étude complète des mots-clés et opportunités SEO',
    status: 'pending',
    priority: 'high',
    subtasks: [
      { id: 'sub-015-1', title: 'Analyse concurrentielle', completed: false },
      { id: 'sub-015-2', title: 'Recherche mots-clés (FR + 2 langues)', completed: false },
      { id: 'sub-015-3', title: 'Clustering et priorisation', completed: false },
      { id: 'sub-015-4', title: 'Créer la stratégie de contenu', completed: false },
    ]
  },
  {
    id: 'check-016',
    category: 'operational',
    title: 'Configuration Tableau de bord STRATOS',
    description: 'Ajouter le client dans la plateforme STRATOS',
    status: 'pending',
    priority: 'medium',
    subtasks: [
      { id: 'sub-016-1', title: 'Créer le profil client dans STRATOS', completed: false },
      { id: 'sub-016-2', title: 'Configurer les KPIs personnalisés', completed: false },
      { id: 'sub-016-3', title: 'Envoyer les identifiants d\'accès au client', completed: false },
    ]
  },
  {
    id: 'check-017',
    category: 'operational',
    title: 'Plan d\'action détaillé',
    description: 'Créer la feuille de route SEO pour les 6 premiers mois',
    status: 'pending',
    priority: 'medium',
    subtasks: [
      { id: 'sub-017-1', title: 'Lister les optimisations prioritaires', completed: false },
      { id: 'sub-017-2', title: 'Planifier le calendrier éditorial', completed: false },
      { id: 'sub-017-3', title: 'Définir les jalons et livrables', completed: false },
      { id: 'sub-017-4', title: 'Valider avec le client', completed: false },
    ]
  },
  {
    id: 'check-018',
    category: 'operational',
    title: 'Communication et reporting',
    description: 'Mettre en place les outils de communication',
    status: 'pending',
    priority: 'low',
    subtasks: [
      { id: 'sub-018-1', title: 'Choisir canal communication (email, Slack, Teams...)', completed: false },
      { id: 'sub-018-2', title: 'Créer le template de reporting mensuel', completed: false },
      { id: 'sub-018-3', title: 'Planifier les points réguliers', completed: false },
    ]
  },
];

// Client Access Requests
export const clientAccesses: ClientAccess[] = [
  // Client 1 - Le 39V
  {
    id: 'access-001',
    clientId: 'client-001',
    service: 'WordPress Admin',
    url: 'https://le39v.com/wp-admin',
    status: 'requested',
    requestedDate: '2025-11-03',
    notes: 'Accès administrateur complet requis'
  },
  {
    id: 'access-002',
    clientId: 'client-001',
    service: 'Google Analytics',
    status: 'requested',
    requestedDate: '2025-11-03',
    notes: 'Email STRATOS à ajouter comme admin'
  },
  {
    id: 'access-003',
    clientId: 'client-001',
    service: 'Google Search Console',
    url: 'https://search.google.com/search-console',
    status: 'requested',
    requestedDate: '2025-11-03',
  },
  {
    id: 'access-004',
    clientId: 'client-001',
    service: 'Google My Business',
    status: 'requested',
    requestedDate: '2025-11-03',
  },
  
  // Client 2 - Café Max
  {
    id: 'access-005',
    clientId: 'client-002',
    service: 'WordPress Admin',
    url: 'https://cafemax-paris.fr/wp-admin',
    status: 'requested',
    requestedDate: '2025-11-03',
    notes: 'Accès administrateur complet requis'
  },
  {
    id: 'access-006',
    clientId: 'client-002',
    service: 'Google Analytics',
    status: 'requested',
    requestedDate: '2025-11-03',
    notes: 'Email STRATOS à ajouter comme admin'
  },
  {
    id: 'access-007',
    clientId: 'client-002',
    service: 'Google Search Console',
    url: 'https://search.google.com/search-console',
    status: 'requested',
    requestedDate: '2025-11-03',
  },
  {
    id: 'access-008',
    clientId: 'client-002',
    service: 'Google My Business',
    status: 'requested',
    requestedDate: '2025-11-03',
    notes: 'Fiche à créer et optimiser'
  },
];

// Tasks for upcoming work
export const adminTasks: AdminTask[] = [
  // Client 1 Tasks
  {
    id: 'task-001',
    clientId: 'client-001',
    title: 'Audit SEO technique complet',
    description: 'Crawl complet du site, analyse vitesse, mobile-friendly, structure',
    category: 'seo',
    status: 'pending',
    priority: 'high',
    estimatedHours: 8,
    dueDate: '2025-11-10',
    tags: ['audit', 'technique', 'prioritaire']
  },
  {
    id: 'task-002',
    clientId: 'client-001',
    title: 'Recherche mots-clés FR + EN + ES',
    description: 'Étude complète des opportunités SEO sur 3 langues',
    category: 'seo',
    status: 'pending',
    priority: 'high',
    estimatedHours: 6,
    dueDate: '2025-11-12',
    tags: ['keywords', 'international']
  },
  {
    id: 'task-003',
    clientId: 'client-001',
    title: 'Optimisation fiche Google Business',
    description: 'Audit et optimisation complète de la fiche GBP',
    category: 'seo',
    status: 'pending',
    priority: 'medium',
    estimatedHours: 3,
    dueDate: '2025-11-08',
    tags: ['local', 'gbp']
  },
  {
    id: 'task-004',
    clientId: 'client-001',
    title: 'Rapport mensuel SEO',
    description: 'Création et envoi du rapport de performance mensuel',
    category: 'reporting',
    status: 'pending',
    priority: 'medium',
    estimatedHours: 2,
    dueDate: '2025-12-01',
    tags: ['reporting', 'récurrent'],
    recurring: {
      frequency: 'monthly',
      nextOccurrence: '2025-12-01'
    }
  },

  // Client 2 Tasks
  {
    id: 'task-005',
    clientId: 'client-002',
    title: 'Audit SEO technique complet',
    description: 'Crawl complet du site, analyse vitesse, mobile-friendly, structure',
    category: 'seo',
    status: 'pending',
    priority: 'high',
    estimatedHours: 8,
    dueDate: '2025-11-11',
    tags: ['audit', 'technique', 'prioritaire']
  },
  {
    id: 'task-006',
    clientId: 'client-002',
    title: 'Création fiche Google My Business',
    description: 'Créer et optimiser la fiche GBP de A à Z',
    category: 'seo',
    status: 'pending',
    priority: 'high',
    estimatedHours: 4,
    dueDate: '2025-11-08',
    tags: ['local', 'gbp', 'setup']
  },
  {
    id: 'task-007',
    clientId: 'client-002',
    title: 'Recherche mots-clés FR + EN + ES',
    description: 'Étude complète des opportunités SEO sur 3 langues',
    category: 'seo',
    status: 'pending',
    priority: 'high',
    estimatedHours: 6,
    dueDate: '2025-11-13',
    tags: ['keywords', 'international']
  },
  {
    id: 'task-008',
    clientId: 'client-002',
    title: 'Setup Google Analytics & Search Console',
    description: 'Configuration initiale des outils de tracking',
    category: 'technical',
    status: 'pending',
    priority: 'high',
    estimatedHours: 2,
    dueDate: '2025-11-07',
    tags: ['setup', 'analytics']
  },
];

// Getters
export const getAllClients = (): Client[] => clients;

export const getClientById = (id: string): Client | undefined => {
  return clients.find(c => c.id === id);
};

export const getActiveClients = (): Client[] => {
  return clients.filter(c => c.status === 'active');
};

export const getChecklistByClientId = (clientId: string): ChecklistItem[] => {
  // Pour l'instant, on retourne la checklist template
  // Dans une vraie app, on stockerait une checklist par client
  return premiumOnboardingChecklist;
};

export const getClientAccesses = (clientId: string): ClientAccess[] => {
  return clientAccesses.filter(a => a.clientId === clientId);
};

export const getClientTasks = (clientId: string): AdminTask[] => {
  return adminTasks.filter(t => t.clientId === clientId);
};

export const getAllTasks = (): AdminTask[] => adminTasks;

export const getTasksByStatus = (status: 'pending' | 'in_progress' | 'completed' | 'cancelled'): AdminTask[] => {
  return adminTasks.filter(t => t.status === status);
};

export const getTasksDueSoon = (days: number = 7): AdminTask[] => {
  const today = new Date();
  const futureDate = new Date();
  futureDate.setDate(today.getDate() + days);
  
  return adminTasks.filter(t => {
    const dueDate = new Date(t.dueDate);
    return dueDate >= today && dueDate <= futureDate && t.status !== 'completed';
  });
};

// Stats helpers
export const getClientStats = () => {
  const total = clients.length;
  const active = clients.filter(c => c.status === 'active').length;
  const negociation = clients.filter(c => c.status === 'negociation').length;
  const totalRevenue = clients
    .filter(c => c.status === 'active')
    .reduce((sum, c) => sum + c.monthlyRevenue, 0);
  
  return {
    total,
    active,
    negociation,
    totalRevenue,
    potentialRevenue: clients
      .filter(c => c.status === 'negociation')
      .reduce((sum, c) => sum + c.monthlyRevenue, 0)
  };
};

export const getTaskStats = () => {
  const total = adminTasks.length;
  const pending = adminTasks.filter(t => t.status === 'pending').length;
  const inProgress = adminTasks.filter(t => t.status === 'in_progress').length;
  const completed = adminTasks.filter(t => t.status === 'completed').length;
  const overdue = adminTasks.filter(t => {
    const due = new Date(t.dueDate);
    return due < new Date() && t.status !== 'completed';
  }).length;
  
  return {
    total,
    pending,
    inProgress,
    completed,
    overdue,
    completionRate: total > 0 ? Math.round((completed / total) * 100) : 0
  };
};

